import { ReactNode } from "react";
import { AitRow } from "./AitRow";
import { AitRowData } from "./functions/AitRowData";
import { AitRowGroupData } from "./functions/AitRowGroupData";
import { AitLocationBodyRowGroup, AitTablePosition } from "./functions/interface";
import { trGetPositionFromLocation } from "./functions/trGetPositionFromLocation";
import { useTableContext } from "./TableContextProvider";

interface AitRowGroupProps {
  location: AitLocationBodyRowGroup;
}

/**
 * Render a row group and its contained rows.
 *
 * @template T - Row group payload type
 * @param props - Component props
 * @param props.location - The row group location within the table
 */
export const AitRowGroup = <T,>({ location }: AitRowGroupProps): ReactNode => {
  const { state } = useTableContext<T>();
  const thisRowGroup: AitRowGroupData<T> | undefined = trGetPositionFromLocation(
    state,
    location,
    true,
  ).data;

  // Output the rows
  return !thisRowGroup ? null : (
    <tbody>
      {thisRowGroup.rows.map((row: AitRowData<T>, ri: number): React.ReactElement => (
        <AitRow
          key={`row-${ri}-${row.aitid}`}
          location={{
            ...location,
            position: AitTablePosition.bodyRow,
            rowId: row.aitid,
            row: ri,
            rowRepeat: !row.rowRepeat?.match(/^[[\]0,]+$/)
              ? (row.rowRepeat ??
                // istanbul ignore next
                "")
              : undefined,
            isRepeat:
              (row.rowRepeat ??
                // istanbul ignore next
                "") !== "" && row.rowRepeat?.match(/^[[\]0,]+$/) === null,
          }}
        />
      ))}
    </tbody>
  );
};

AitRowGroup.displayName = "AitRowGroup";
